var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-menu"},[_c('div',{staticClass:"navigation-menu__container"},[_c('div',{staticClass:"navigation-menu__header"}),_c('div',{staticClass:"navigation-menu__links"},[_c('NavigationMenuLinks')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }